import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

function index(): JSX.Element {
    const {
        base_config: { site }
    } = useSelector(
        ({ IndexReducer }) => ({
            base_config: IndexReducer.base_config
        }),
        shallowEqual
    );
    return (
        <div className="im-footer">
            <p className="icp">
                <a href="https://beian.miit.gov.cn" rel="noreferrer" target="_blank">
                    {site?.footer}
                </a>
            </p>
        </div>
    );
}

export default index;
